import React from "react";
import Step from "./Step";
import Loadable from "../../react-loadable";
import middleware from "../../middleware";
const WeaIntro = () => <div />;

WeaIntro.Intro = Loadable({
  loader: () => import("./Intro"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
WeaIntro.Step = Step;

const Com = middleware(WeaIntro, "WeaIntro");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-intro/index.js